import {
  onlyDigits,
  formatCpf,
  formatCnpj,
  formatBrazilianPhone,
} from 'shared/helpers/talkviaInputMasks';

// Formats Brazilian E.164 numbers for reading; other countries stay as stored.
export const formatContactPhone = value => {
  const phone = String(value || '').trim();
  const digits = onlyDigits(phone);
  if (!digits.startsWith('55') || ![12, 13].includes(digits.length))
    return phone;
  return `+55 ${formatBrazilianPhone(digits.slice(2))}`;
};

// CPF and CNPJ keep leading zeros; unexpected lengths are shown unchanged.
export const formatContactDocument = value => {
  const document = String(value || '').trim();
  const digits = onlyDigits(document);
  if (digits.length === 11) return formatCpf(digits);
  if (digits.length === 14) return formatCnpj(digits);
  return document;
};

export const formatContactDate = value => {
  if (!value) return '';
  const isoDate = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoDate) return `${isoDate[3]}/${isoDate[2]}/${isoDate[1]}`;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('pt-BR');
};

// Unix seconds (contact.lastActivityAt) take precedence over the profile ISO date.
export const contactLastInteraction = (lastActivityAt, profileDate) => {
  if (lastActivityAt) return new Date(Number(lastActivityAt) * 1000);
  if (!profileDate) return null;
  const date = new Date(profileDate);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const pipelineStatuses = summary => {
  const data = summary || {};
  return [
    { key: 'IN_PROGRESS', count: data.inProgress || 0, tone: 'bg-n-amber-9' },
    { key: 'PAID', count: data.paid || 0, tone: 'bg-n-teal-9' },
    { key: 'CANCELED', count: data.canceled || 0, tone: 'bg-n-ruby-9' },
  ].filter(status => status.count > 0);
};
